import React, { useState } from "react";
import { Button, Tooltip, Badge } from "antd";
import { Drawer } from "antd5";
import { CustomerServiceOutlined, CloseOutlined, ArrowLeftOutlined, ExpandAltOutlined, InfoCircleOutlined } from "@ant-design/icons";
import ListaTicketsSoporte from "./ListaTicketsSoporte";
import HiloMensajesSoporte from "./HiloMensajesSoporte";
import InfoReporte from "./InfoReporte";
import TagFase from "./TagFase";
import TagRespuestaCliente from "./TagRespuestaCliente";
import AccionesSubido from "./AccionesSubido";
import AccionesPeticion from "./AccionesPeticion";
import { ButtonItem, SegmentedItem } from "../../../../Components/Items";
import useAltoVisible from "./useAltoVisible";
import {
  SOPORTE_TEMA,
  chatCerrado,
  textoChatCerrado,
  textoChatCerradoAgente,
} from "./fasesSoporte";

const ANCHO_BURBUJA = 380;
const ALTO_NAVBAR = 64;

const BurbujaSoporte = ({
  abierto,
  onCerrar,
  tickets,
  ticketActivo,
  mensajes,
  loadingMensajes,
  loadingTickets,
  enviando,
  seleccionarTicket,
  volverALista,
  enviarMensaje,
  onNuevoTicket,
  onAbrirVistaCompleta,
  soloLectura,
  esMaster,
  usuarioId,
  modoSoporte,
  modoPeticiones,
  pestanas,
  headersToken,
  onPeticionRevisada,
  esMovil,
  respondiendo,
  onResponderSubido,
  busqueda,
  onBuscar,
  buscando,
  totalRecords,
  hayMas,
  cargandoMas,
  onCargarMas,
}) => {
  const [panelInfoVisible, setPanelInfoVisible] = useState(false);
  const { alto, top } = useAltoVisible();
  const enTicket = !!ticketActivo;

  // El sí/no lo responde el cliente: en modo soporte no se muestra (y el backend
  // también lo bloquea, porque sería un dato falso).
  const puedeResponderSubido = enTicket && !modoSoporte && !!onResponderSubido;
  const chatBloqueado =
    enTicket && (chatCerrado(ticketActivo.fase) || (modoPeticiones && ticketActivo.fase !== "en_revision"));

  const accionesPeticion = enTicket && modoPeticiones && (
    <AccionesPeticion ticket={ticketActivo} headersToken={headersToken} onRevisada={onPeticionRevisada} compacto />
  );

  const volver = () => {
    setPanelInfoVisible(false);
    volverALista();
  };
  const cerrar = () => {
    setPanelInfoVisible(false);
    onCerrar();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: esMovil ? top : ALTO_NAVBAR,
        right: 0,
        bottom: esMovil ? undefined : 0,
        height: esMovil ? alto : undefined,
        width: esMovil ? "100vw" : ANCHO_BURBUJA,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: SOPORTE_TEMA.surface,
          borderLeft: `1px solid ${SOPORTE_TEMA.border}`,
          boxShadow: "-2px 0 10px rgba(0,0,0,0.12)",
          display: "flex",
          flexDirection: "column",
          transform: abierto ? "translateX(0)" : "translateX(100%)",
          visibility: abierto ? "visible" : "hidden",
          transition: "transform 0.25s ease, visibility 0.25s ease",
          pointerEvents: abierto ? "auto" : "none",
        }}
      >
        <div
          style={{
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            padding: enTicket ? "6px 8px" : "10px 12px",
            borderBottom: `1px solid ${SOPORTE_TEMA.border}`,
            backgroundColor: SOPORTE_TEMA.surface,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
            {enTicket ? (
              <Button type="text" size="small" icon={<ArrowLeftOutlined />} onClick={volver} />
            ) : (
              <CustomerServiceOutlined style={{ fontSize: 18, color: SOPORTE_TEMA.primarioFuerte }} />
            )}
            <span
              style={{
                fontWeight: 600,
                color: SOPORTE_TEMA.textPrimary,
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {enTicket
                ? `${ticketActivo.folio} — ${ticketActivo.titulo}`
                : modoSoporte
                  ? "Bandeja de soporte"
                  : modoPeticiones
                    ? "Peticiones de soporte"
                    : "Soporte"}
            </span>
            {enTicket && <TagFase fase={ticketActivo.fase} />}
            {enTicket && <TagRespuestaCliente respuesta={ticketActivo.respuestaCliente} />}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
            {enTicket && esMovil && (
              <ButtonItem
                blanco
                lessTime
                icon={<InfoCircleOutlined />}
                onClick={() => setPanelInfoVisible(true)}
                style={{ width: 32, height: 32, borderRadius: "50%", padding: 0 }}
              />
            )}
            {enTicket && onAbrirVistaCompleta && !modoSoporte && !modoPeticiones && (
              <Tooltip title="Ver en grande">
                <Button
                  type="text"
                  size="small"
                  icon={<ExpandAltOutlined />}
                  onClick={() => onAbrirVistaCompleta(ticketActivo._id)}
                />
              </Tooltip>
            )}
            <Button type="text" size="small" icon={<CloseOutlined />} onClick={cerrar} />
          </div>
        </div>

        {enTicket ? (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
            {!esMovil && (
              <div
                style={{
                  maxHeight: 220,
                  overflowY: "auto",
                  padding: "10px 12px 0",
                  borderBottom: `1px solid ${SOPORTE_TEMA.border}`,
                  flexShrink: 0,
                }}
              >
                {puedeResponderSubido && (
                  <div style={{ marginBottom: 12 }}>
                    <AccionesSubido
                      ticket={ticketActivo}
                      guardando={respondiendo}
                      onResponder={(respuesta) => onResponderSubido(ticketActivo._id, respuesta)}
                      compacto
                    />
                  </div>
                )}
                {accionesPeticion && <div style={{ marginBottom: 12 }}>{accionesPeticion}</div>}
                <InfoReporte ticket={ticketActivo} perspectivaAgente={!!modoSoporte} />
              </div>
            )}
            <HiloMensajesSoporte
              mensajes={mensajes}
              loading={loadingMensajes}
              enviando={enviando}
              onEnviar={enviarMensaje}
              perspectivaAgente={!!modoSoporte}
              usuarioId={usuarioId}
              soloLectura={soloLectura || chatBloqueado}
              textoSoloLectura={
                chatCerrado(ticketActivo.fase)
                  ? modoSoporte
                    ? textoChatCerradoAgente(ticketActivo.fase)
                    : textoChatCerrado(ticketActivo.fase)
                  : chatBloqueado
                    ? "Esta petición ya fue revisada."
                    : undefined
              }
            />
          </div>
        ) : (
          <div style={{ flex: 1, overflowY: "auto" }}>
            {pestanas && (
              <div style={{ padding: "8px 12px 0" }}>
                <SegmentedItem
                  style={{ width: "100%" }}
                  value={pestanas.valor}
                  onChange={pestanas.onChange}
                  options={[
                    {
                      value: "tickets",
                      label: (
                        <span>
                          Mis tickets <Badge count={pestanas.noLeidosTickets} size="small" overflowCount={99} />
                        </span>
                      ),
                    },
                    {
                      value: "peticiones",
                      label: (
                        <span>
                          Peticiones <Badge count={pestanas.noLeidosPeticiones} size="small" overflowCount={99} />
                        </span>
                      ),
                    },
                  ]}
                />
              </div>
            )}
            <ListaTicketsSoporte
              tickets={tickets}
              loading={loadingTickets}
              onSelect={seleccionarTicket}
              onNuevoTicket={onNuevoTicket}
              mostrarReportero={esMaster || modoSoporte || modoPeticiones}
              usuarioId={usuarioId}
              modoSoporte={modoSoporte}
              modoPeticiones={modoPeticiones}
              anchoTexto={esMovil ? "100%" : undefined}
              busqueda={busqueda}
              onBuscar={onBuscar}
              buscando={buscando}
              totalRecords={totalRecords}
              hayMas={hayMas}
              cargandoMas={cargandoMas}
              onCargarMas={onCargarMas}
            />
          </div>
        )}
      </div>

      {esMovil && enTicket && (
        <Drawer
          placement="bottom"
          height="88%"
          open={panelInfoVisible}
          onClose={() => setPanelInfoVisible(false)}
          title="Detalle del reporte"
          styles={{ body: { padding: "12px 16px" } }}
        >
          {puedeResponderSubido && (
            <div style={{ marginBottom: 14 }}>
              <AccionesSubido
                ticket={ticketActivo}
                guardando={respondiendo}
                onResponder={(respuesta) => onResponderSubido(ticketActivo._id, respuesta)}
                compacto
              />
            </div>
          )}
          {accionesPeticion && <div style={{ marginBottom: 14 }}>{accionesPeticion}</div>}
          <InfoReporte ticket={ticketActivo} mostrarNotasInternas={!!modoSoporte} perspectivaAgente={!!modoSoporte} />
        </Drawer>
      )}
    </div>
  );
};

export default BurbujaSoporte;
